import React, { useState } from "react";
import Icone from "./Icone";

/**
 * « Où trouver mon numéro ? » : aide dépliable sous le champ NIR, avec le
 * spécimen de carte Vitale déjà servi par le portail.
 */
const AideNir = ({ id = "aide-nir" }) => {
  const [ouverte, setOuverte] = useState(false);
  return (
    <div className="aide-nir">
      <button
        type="button"
        className="lien aide-nir__bouton"
        aria-expanded={ouverte}
        aria-controls={id}
        onClick={() => setOuverte((o) => !o)}
      >
        <Icone nom="info" epaisseur={2.2} />
        Où trouver mon numéro ?
      </button>
      {ouverte && (
        <div id={id} className="aide-nir__contenu">
          <img src="/assets/carte-vitale.png" alt="Spécimen de carte Vitale : le numéro est encadré en bas de la carte" />
          <p>
            Votre numéro de sécurité sociale figure au recto de votre carte Vitale, sous votre nom : 13
            chiffres suivis d'une clé de 2 chiffres. Saisissez le vôtre, pas celui du spécimen.
          </p>
        </div>
      )}
    </div>
  );
};

export default AideNir;
